export default __webpack_public_path__ + "daa29bca6f941ba72d795c2758ff7edf.png";